var contactData = {
    section:"Contactez moi",
    button:"Envoyer un Email",
}

exports.contactData = contactData